module.exports = __webpack_public_path__ + "img/order-fill.1ff02368.png";